import { Component, input, signal, output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpService } from '../../../service/http/http.service';
import { environment } from '@environments/environment';
import { backendRestApis } from '@environments/backend-rest-apis';

@Component({
  selector: 'app-ride-name-editor',
  imports: [FormsModule, CommonModule],
  templateUrl: './ride-name-editor.component.html',
  styleUrl: './ride-name-editor.component.css'
})
/**
 * Inline editor for renaming a ride from the ride history view.
 *
 * The component keeps a local editable copy of the current ride name,
 * allows the user to enter edit mode, and persists a changed name through
 * the backend API when saved.
 */
export class RideNameEditorComponent {

  rideId = input.required<number>();

  initialName = input<string>('');

  nameUpdated = output<string>();

  isEditing = signal(false);

  currentName = signal('');

  inputValue = signal('');

  private httpService = inject(HttpService);

  ngOnInit() {
    this.currentName.set(this.initialName());
  }

  /** Opens the editor and pre-fills it with the current name. */
  startEditing() {
    this.inputValue.set(this.currentName());
    this.isEditing.set(true);
  }

  /** Saves the edited name if it is non-empty and different from the current one. */
  save() {
    const name = this.inputValue().trim();
  
  if (!name) {
    this.isEditing.set(false);
    return;
  }

  if (name === this.currentName()) {
    this.isEditing.set(false);
    return;
  }

    const url = `${environment.apiUrl}${backendRestApis.ride.updateRideName(this.rideId())}`;
    this.httpService.patch<string>(url, name).subscribe({
      next: () => {
        this.currentName.set(name);
        this.nameUpdated.emit(name);
        this.isEditing.set(false);
      }
    });
  }

  /** Closes the editor without applying any changes. */
  cancel() {
    this.isEditing.set(false);
  }
}